
<template>
  <div>
    <!-- 入力フォーム全角半角自動切換えはtype="tel"で実装している -->
    <CRow>
      <CCol lg="12">
        <CCard>
          <CCardHeader>
            <h3 class="card-title mb-3">会員検索</h3>
            <CForm class="search-filter" @submit.prevent>
              <CRow class="mb-2">
                <CCol lg="5">
                  <!-- <CInput
                    id="cardIDForm"
                    autofocus
                    label="カードID"
                    class="search-input"
                    placeholder="カードIDを入力（完全一致）"
                    horizontal
                    v-model="query.cardId"
                    @keydown.enter="onSearchQuery($event, 'cardId')"
                    type="number"
                  /> -->

                  <div class="form-group form-row ml-1">
                    <label class="col-form-label col-sm-3">カードID</label>
                    <div class="col-sm-9">
                      <input
                        type="text"
                        placeholder="カードIDを入力（完全一致）"
                        class="form-control"
                        v-model="ConvertId"
                        autofocus
                        @keydown.enter="onSearchQuery($event, 'cardId')"
                      />
                    </div>
                  </div>
                </CCol>
                <CCol lg="2">
                  <CButton
                    @click="getSearchQuery('cardId')"
                    class="info-button w-100"
                    :disabled="$v.query.cardId.$invalid"
                  >
                    <i class="icon cil-search"></i> 検索
                  </CButton>
                </CCol>
              </CRow>
            </CForm>
            <!-- <transition name="fade">
              <CRow v-if="updateUserComplete" >
                <CCol lg="6">
                  <CAlert color="success" >カード会員登録が完了しました</CAlert>
                </CCol>
              </CRow>
            </transition> -->
            <transition name="fade">
              <CRow v-if="notFound">
                <CCol lg="6">
                  <CAlert color="danger">カードIDが存在しません</CAlert>
                </CCol>
              </CRow>
            </transition>
          </CCardHeader>
        </CCard>
      </CCol>
    </CRow>

    <CRow>
      <CCol lg="12">
        <CCard>
          <CCardHeader>
            <h3 class="card-title">会員情報</h3>
          </CCardHeader>
          <CCardBody>
            <CForm class="member-info edit-form">
              <CRow>
                <CCol class="px-0 pb-3">
                  <h4 class="sub-title">登録情報</h4>
                </CCol>
              </CRow>

              <CRow>
                <CCol lg="6">
                  <CInput
                    tabIndex="-1"
                    label="カードID"
                    horizontal
                    plaintext
                    required
                    v-model="cardUserData.cardId"
                  />
                </CCol>
              </CRow>

              <CRow>
                <CCol lg="6">
                  <div class="required-mark form-group form-row">
                    <label class="col-form-label col-sm-3">氏</label>
                    <div class="col-sm-9">
                      <input
                        type="text"
                        class="form-control"
                        v-model="cardUserData.familyName"
                        v-on:input="familyName_furigana"
                      />
                      <!-- v-model="cardUserData.familyName" -->
                    </div>
                  </div>
                  <div
                    class="text-danger input-info"
                    v-if="
                      $v.cardUserData.familyName.$dirty &&
                      !$v.cardUserData.familyName.required
                    "
                  >
                    氏の入力は必須です
                  </div>
                  <div
                    class="text-danger input-info"
                    v-if="
                      $v.cardUserData.familyName.$dirty &&
                      !$v.cardUserData.familyName.maxLength
                    "
                  >
                    100文字以上入力できません
                  </div>
                </CCol>
                <CCol lg="6">
                  <div class="required-mark form-group form-row">
                    <label class="col-form-label col-sm-3">名</label>
                    <div class="col-sm-9">
                      <input
                        type="text"
                        class="form-control"
                        v-model="cardUserData.givenName"
                        v-on:input="givenName_furigana"
                      />
                      <!-- v-model="cardUserData.givenName" -->
                    </div>
                  </div>
                  <div
                    class="text-danger input-info"
                    v-if="
                      $v.cardUserData.givenName.$dirty &&
                      !$v.cardUserData.givenName.required
                    "
                  >
                    名の入力は必須です
                  </div>
                  <div
                    class="text-danger input-info"
                    v-if="
                      $v.cardUserData.givenName.$dirty &&
                      !$v.cardUserData.givenName.maxLength
                    "
                  >
                    100文字以上入力できません
                  </div>
                </CCol>
              </CRow>

              <CRow>
                <CCol lg="6">
                  <CInput
                    label="氏（カナ）"
                    class="required-mark"
                    horizontal
                    v-model="cardUserData.firstName"
                  />
                  <div
                    class="text-danger input-info"
                    v-if="
                      $v.cardUserData.firstName.$dirty &&
                      !$v.cardUserData.firstName.required
                    "
                  >
                    氏（カナ）の入力は必須です
                  </div>
                  <div
                    class="text-danger input-info"
                    v-if="
                      $v.cardUserData.firstName.$dirty &&
                      !$v.cardUserData.firstName.maxLength
                    "
                  >
                    100文字以上入力できません
                  </div>
                  <div
                    class="text-danger input-info"
                    v-if="
                      $v.cardUserData.firstName.$dirty &&
                      !$v.cardUserData.firstName.isKana
                    "
                  >
                    氏（カナ）はカタカナを入力してください
                  </div>
                </CCol>
                <CCol lg="6">
                  <CInput
                    label="名（カナ）"
                    class="required-mark"
                    horizontal
                    v-model="cardUserData.lastName"
                  />
                  <div
                    class="text-danger input-info"
                    v-if="
                      $v.cardUserData.lastName.$dirty &&
                      !$v.cardUserData.lastName.required
                    "
                  >
                    名（カナ）の入力は必須です
                  </div>
                  <div
                    class="text-danger input-info"
                    v-if="
                      $v.cardUserData.lastName.$dirty &&
                      !$v.cardUserData.lastName.maxLength
                    "
                  >
                    100文字以上入力できません
                  </div>
                  <div
                    class="text-danger input-info"
                    v-if="
                      $v.cardUserData.lastName.$dirty &&
                      !$v.cardUserData.lastName.isKana
                    "
                  >
                    名（カナ）はカタカナを入力してください
                  </div>
                </CCol>
              </CRow>
              <CRow>
                <CCol lg="6">
                  <!-- <div
                    class="text-danger input-info"
                    v-if="!$v.cardUserData.birth.maxLength"
                  >
                    8桁以上入力できません
                  </div> -->
                  <CInput
                    label="生年月日"
                    type="date"
                    min="1900-01-01"
                    max="2100-12-31"
                    horizontal
                    required
                    v-model="cardUserData.birth"
                  />
                </CCol>

                <CCol lg="6">
                  <CSelect
                    label="性別"
                    horizontal
                    :options="options.genderOptions"
                    :value.sync="cardUserData.gender"
                  />
                </CCol>
              </CRow>

              <CRow>
                <CCol class="px-0 py-3"
                  ><h4 class="sub-title">連絡情報</h4></CCol
                >
              </CRow>

              <CRow>
                <CCol lg="6">
                  <div
                    class="text-danger input-info"
                    v-if="!$v.cardUserData.email.email"
                  >
                    有効なメールアドレスではありません
                  </div>
                  <!-- <div
                    class="text-danger input-info"
                    v-if="!$v.cardUserData.email.required"
                  >
                    メールアドレスの入力は必須です
                  </div> -->

                  <CInput
                    label="メールアドレス"
                    type="email"
                    horizontal
                    required
                    v-model="cardUserData.email"
                  />
                </CCol>
              </CRow>

              <CRow>
                <CCol lg="6">
                  <CInput
                    label="電話番号"
                    class="required-mark"
                    description="ハイフン（-）なしで入力"
                    horizontal
                    required
                    v-model="cardUserData.mobile"
                    type="tel"
                  />
                  <div
                    class="text-danger input-info"
                    v-if="
                      $v.cardUserData.mobile.$dirty &&
                      !$v.cardUserData.mobile.required
                    "
                  >
                    電話番号の入力は必須です
                  </div>

                  <div
                    class="text-danger input-info"
                    v-if="
                      $v.cardUserData.mobile.$dirty &&
                      !$v.cardUserData.mobile.maxLength
                    "
                  >
                    15桁以上入力できません
                  </div>

                  <div
                    class="text-danger input-info"
                    v-if="
                      $v.cardUserData.mobile.$dirty &&
                      !$v.cardUserData.mobile.numeric
                    "
                  >
                    半角数字を入力してください
                  </div>
                </CCol>
              </CRow>

              <CRow>
                <CCol class="px-0 py-3">
                  <h4 class="sub-title">住所</h4>
                </CCol>
              </CRow>

              <CRow>
                <CCol lg="6">
                  <div
                    class="text-danger input-info"
                    v-if="!$v.cardUserData.address.zipCode.maxLength"
                  >
                    20桁以上入力できません
                  </div>
                  <CInput
                    label="郵便番号"
                    horizontal
                    required
                    v-model="cardUserData.address.zipCode"
                    type="tel"
                  />
                </CCol>
                <CCol lg="4">
                  <CButton color="success" @click="onInputAddressClick()"
                    ><i class="icon cil-location-pin"></i> 住所自動入力</CButton
                  >
                </CCol>
              </CRow>

              <CRow>
                <CCol lg="6">
                  <div
                    class="text-danger input-info"
                    v-if="!$v.cardUserData.address.state.maxLength"
                  >
                    50文字以上入力できません
                  </div>
                  <CInput
                    label="都道府県"
                    horizontal
                    required
                    v-model="cardUserData.address.state"
                  />
                </CCol>

                <CCol lg="6">
                  <div
                    class="text-danger input-info"
                    v-if="!$v.cardUserData.address.city.maxLength"
                  >
                    50文字以上入力できません
                  </div>
                  <CInput
                    label="市区町村"
                    horizontal
                    required
                    v-model="cardUserData.address.city"
                  />
                </CCol>
              </CRow>

              <CRow>
                <CCol lg="6">
                  <div
                    class="text-danger input-info"
                    v-if="!$v.cardUserData.address.address1.maxLength"
                  >
                    50文字以上入力できません
                  </div>
                  <CInput
                    label="地番番地"
                    horizontal
                    required
                    v-model="cardUserData.address.address1"
                  />
                </CCol>

                <CCol lg="6">
                  <div
                    class="text-danger input-info"
                    v-if="!$v.cardUserData.address.address2.maxLength"
                  >
                    50文字以上入力できません
                  </div>
                  <CInput
                    label="建物・その他"
                    horizontal
                    required
                    v-model="cardUserData.address.address2"
                  />
                </CCol>
              </CRow>
            </CForm>
          </CCardBody>
        </CCard>

        <!-- 家族情報 -->
        <CRow>
          <CCol lg="12">
            <CCard>
              <CCardHeader>
                <CRow>
                  <CCol>
                    <h4 class="sub-title">家族情報</h4>
                  </CCol>
                </CRow>
              </CCardHeader>

              <CCardBody>
                <CRow>
                  <CCol class="mb-3">
                    <CButton
                      id="completeFamilyModal"
                      @click="onFamilyAddClick()"
                      color="info"
                      :disabled="$v.cardUserData.$invalid || $v.query.$invalid"
                    >
                      <i class="icon cil-cardUser-follow"></i> 家族登録</CButton
                    >
                  </CCol>
                </CRow>
                <!-- <transition name="fade">
                  <CRow v-if="familyNotFound">
                    <CCol lg="6">
                      <CAlert color="danger">家族情報の登録はありません</CAlert>
                    </CCol>
                  </CRow>
                </transition> -->
                <CRow>
                  <CCol
                    lg="6"
                    v-for="data in families"
                    :key="data.id"
                    class="float-left"
                  >
                    <CCard>
                      <CCardHeader>
                        <CInput
                          label="カードID"
                          horizontal
                          plaintext
                          v-model="data.relative.cardId"
                        />
                      </CCardHeader>
                      <CCardBody>
                        <CForm class="member-info edit-form">
                          <CRow>
                            <CCol lg="12">
                              <CInput
                                label="氏"
                                horizontal
                                plaintext
                                v-model="data.relative.familyName"
                              />
                            </CCol>
                            <CCol lg="12">
                              <CInput
                                label="氏（カナ）"
                                horizontal
                                plaintext
                                v-model="data.relative.lastName"
                              />
                            </CCol>
                            <CCol lg="12">
                              <CInput
                                label="名"
                                horizontal
                                plaintext
                                v-model="data.relative.givenName"
                              />
                            </CCol>
                            <CCol lg="12">
                              <CInput
                                label="名（カナ）"
                                horizontal
                                plaintext
                                v-model="data.relative.firstName"
                              />
                            </CCol>

                            <CCol lg="12">
                              <CSelect
                                label="関係"
                                horizontal
                                disabled
                                :options="options.relationOptions"
                                :value.sync="data.description"
                              />
                              <!-- v-model="data.name" /> -->
                            </CCol>

                            <CCol lg="12">
                              <CSelect
                                label="性別"
                                horizontal
                                disabled
                                :options="options.genderOptions"
                                v-model="data.relative.gender"
                              />
                            </CCol>

                            <CCol lg="12">
                              <!-- <CInput
                                label="生年月日"
                                horizontal
                                plaintext
                                v-model="data.relative.birth"
                              /> -->
                              <div class="form-group form-row">
                                <label class="col-form-label col-sm-3"
                                  >生年月日</label
                                >
                                <div class="col-sm-9">
                                  <span>{{
                                    data.relative.birth | formatDate
                                  }}</span>
                                </div>
                              </div>
                            </CCol>
                          </CRow>
                        </CForm>
                      </CCardBody>
                      <CCardFooter>
                        <CButton
                          @click="onFamilyEditClick(data.id)"
                          color="info"
                          ><i class="icon cil-pencil"></i> 編集</CButton
                        >
                      </CCardFooter>
                    </CCard>
                  </CCol>
                </CRow>
              </CCardBody>
            </CCard>
          </CCol>

          <CModal
            color="dark"
            :closeOnBackdrop="false"
            :centered="true"
            :show.sync="addFamilyModal"
          >
            <template #header>
              <h4>家族登録</h4>
            </template>
            <div class="member-info">
              <CRow>
                <CCol lg="12">
                  <div class="required-mark form-group form-row">
                    <label class="col-form-label col-sm-3">氏</label>
                    <div class="col-sm-9">
                      <input
                        autofocus
                        type="text"
                        class="form-control"
                        v-model="familyAdd.familyName"
                        v-on:input="familySave_familyName_furigana"
                      />
                      <!-- v-on:input="familySave_familyName_furigana" -->
                    </div>
                  </div>
                  <div
                    class="text-danger input-info"
                    v-if="
                      $v.familyAdd.familyName.$dirty &&
                      !$v.familyAdd.familyName.required
                    "
                  >
                    氏の入力は必須です
                  </div>
                  <div
                    class="text-danger input-info"
                    v-if="
                      $v.familyAdd.familyName.$dirty &&
                      !$v.familyAdd.familyName.maxLength
                    "
                  >
                    100文字以上入力できません
                  </div>

                  <!-- <CInput
                  autofocus
                  label="氏"
                  class="required-mark"
                  horizontal
                  v-model="familyAdd.familyName"
                /> -->

                  <!-- <div
                          class="text-danger input-info"
                          v-if="!$v.familyAdd.givenName.required"
                        >
                          氏の入力は必須です
                        </div> -->
                </CCol>

                <CCol lg="12">
                  <CInput
                    label="氏（カナ）"
                    class="required-mark"
                    horizontal
                    v-model="familyAdd.firstName"
                  />
                  <div
                    class="text-danger input-info"
                    v-if="
                      $v.familyAdd.firstName.$dirty &&
                      !$v.familyAdd.firstName.required
                    "
                  >
                    氏（カナ）の入力は必須です
                  </div>
                  <div
                    class="text-danger input-info"
                    v-if="
                      $v.familyAdd.firstName.$dirty &&
                      !$v.familyAdd.firstName.maxLength
                    "
                  >
                    100文字以上入力できません
                  </div>
                  <div
                    class="text-danger input-info"
                    v-if="
                      $v.familyAdd.firstName.$dirty &&
                      !$v.familyAdd.firstName.isKana
                    "
                  >
                    氏（カナ）はカタカナを入力してください
                  </div>
                </CCol>

                <CCol lg="12">
                  <div class="required-mark form-group form-row">
                    <label class="col-form-label col-sm-3">名</label>
                    <div class="col-sm-9">
                      <input
                        autofocus
                        type="text"
                        class="form-control"
                        v-model="familyAdd.givenName"
                        v-on:input="familySave_givenName_furigana"
                      />
                      <!-- v-on:input="familySave_givenName_furigana" -->
                    </div>
                  </div>
                  <div
                    class="text-danger input-info"
                    v-if="
                      $v.familyAdd.givenName.$dirty &&
                      !$v.familyAdd.givenName.required
                    "
                  >
                    名の入力は必須です
                  </div>
                  <div
                    class="text-danger input-info"
                    v-if="
                      $v.familyAdd.givenName.$dirty &&
                      !$v.familyAdd.givenName.maxLength
                    "
                  >
                    100文字以上入力できません
                  </div>

                  <!-- <CInput
                label="名"
                class="required-mark"
                horizontal
                v-model="familyAdd.givenName" /> -->
                  <!-- <div
                          class="text-danger input-info"
                          v-if="!$v.familyAdd.familyName.required"
                        >
                          名の入力は必須です
                        </div> -->
                </CCol>

                <CCol lg="12">
                  <CInput
                    label="名（カナ）"
                    class="required-mark"
                    horizontal
                    v-model="familyAdd.lastName"
                  />
                  <div
                    class="text-danger input-info"
                    v-if="
                      $v.familyAdd.lastName.$dirty &&
                      !$v.familyAdd.lastName.required
                    "
                  >
                    名（カナ）の入力は必須です
                  </div>
                  <div
                    class="text-danger input-info"
                    v-if="
                      $v.familyAdd.lastName.$dirty &&
                      !$v.familyAdd.lastName.maxLength
                    "
                  >
                    100文字以上入力できません
                  </div>
                  <div
                    class="text-danger input-info"
                    v-if="
                      $v.familyAdd.lastName.$dirty &&
                      !$v.familyAdd.lastName.isKana
                    "
                  >
                    名（カナ）はカタカナを入力してください
                  </div>
                </CCol>

                <CCol lg="12">
                  <CSelect
                    label="関係"
                    horizontal
                    :options="options.relationOptions"
                    :value.sync="familyAdd.relation"
                  />
                  <!-- <div
                          class="text-danger input-info"
                          v-if="!$v.familyAdd.relation.required"
                        >
                          関係の入力は必須です
                        </div> -->
                </CCol>

                <CCol lg="12">
                  <CSelect
                    label="性別"
                    horizontal
                    :options="options.genderOptions"
                    :value.sync="familyAdd.gender"
                  />
                  <!-- <div
                          class="text-danger input-info"
                          v-if="!$v.familyAdd.gender.required"
                        >
                          性別の入力は必須です
                        </div> -->
                </CCol>
                <CCol lg="12">
                  <!-- <div
                          class="text-danger input-info"
                          v-if="!$v.familyAdd.birth.maxLength"
                        >
                          8桁以上入力できません
                        </div> -->
                  <CInput
                    label="生年月日"
                    type="date"
                    min="1900-01-01"
                    max="2100-12-31"
                    horizontal
                    v-model="familyAdd.birth"
                  />
                  <!-- <div
                          class="text-danger input-info"
                          v-if="!$v.familyAdd.birth.required"
                        >
                          生年月日の入力は必須です
                        </div> -->
                </CCol>
              </CRow>
            </div>
            <template #footer>
              <CButton
                @click="addFamilyModal = false"
                color="secondary"
                class="float-left"
              >
                <i class="icon cil-x"></i> キャンセル
              </CButton>
              <CButton
                @click="
                  $v.familyAdd.$invalid
                    ? $v.familyAdd.$touch()
                    : onFamilyAddRunClick()
                "
                color="success"
                v-bind:class="$v.familyAdd.$invalid ? 'inactive' : 'active'"
              >
                <i class="icon cil-save"></i> 登録
              </CButton>
              <!-- <CButton
                        @click="onFamilyAddRunClick()"
                        color="success"
                        :disabled="$v.familyAdd.$invalid"
                      >
                        <i class="icon cil-save"></i> 登録
                      </CButton> -->
            </template>
          </CModal>

          <CModal
            color="dark"
            :closeOnBackdrop="false"
            :centered="true"
            :show.sync="editFamilyModal"
          >
            <template #header>
              <h4>家族編集</h4>
            </template>
            <div class="member-info">
              <CRow>
                <CCol lg="12">
                  <div class="required-mark form-group form-row">
                    <label class="col-form-label col-sm-3">氏</label>
                    <div class="col-sm-9">
                      <input
                        autofocus
                        type="text"
                        class="form-control"
                        v-model="familyEdit.familyName"
                        v-on:input="familyEdit_familyName_furigana"
                      />
                      <!-- v-on:input="familyEdit_familyName_furigana" -->
                    </div>
                  </div>
                  <div
                    class="text-danger input-info"
                    v-if="
                      $v.familyEdit.familyName.$dirty &&
                      !$v.familyEdit.familyName.required
                    "
                  >
                    氏の入力は必須です
                  </div>
                  <div
                    class="text-danger input-info"
                    v-if="
                      $v.familyEdit.familyName.$dirty &&
                      !$v.familyEdit.familyName.maxLength
                    "
                  >
                    100文字以上入力できません
                  </div>

                  <!-- <CInput 
                label="氏"
                class="required-mark"
                horizontal
                v-model="familyEdit.familyName" /> -->
                </CCol>

                <CCol lg="12">
                  <CInput
                    label="氏（カナ）"
                    class="required-mark"
                    horizontal
                    v-model="familyEdit.firstName"
                  />
                  <div
                    class="text-danger input-info"
                    v-if="
                      $v.familyEdit.firstName.$dirty &&
                      !$v.familyEdit.firstName.required
                    "
                  >
                    氏（カナ）の入力は必須です
                  </div>
                  <div
                    class="text-danger input-info"
                    v-if="
                      $v.familyEdit.firstName.$dirty &&
                      !$v.familyEdit.firstName.maxLength
                    "
                  >
                    100文字以上入力できません
                  </div>
                  <div
                    class="text-danger input-info"
                    v-if="
                      $v.familyEdit.firstName.$dirty &&
                      !$v.familyEdit.firstName.isKana
                    "
                  >
                    氏（カナ）はカタカナを入力してください
                  </div>
                </CCol>

                <CCol lg="12">
                  <div class="required-mark form-group form-row">
                    <label class="col-form-label col-sm-3">名</label>
                    <div class="col-sm-9">
                      <input
                        autofocus
                        type="text"
                        class="form-control"
                        v-model="familyEdit.givenName"
                        v-on:input="familyEdit_givenName_furigana"
                      />
                      <!-- v-on:input="familyEdit_givenName_furigana" -->
                    </div>
                  </div>
                  <div
                    class="text-danger input-info"
                    v-if="
                      $v.familyEdit.givenName.$dirty &&
                      !$v.familyEdit.givenName.required
                    "
                  >
                    名の入力は必須です
                  </div>
                  <div
                    class="text-danger input-info"
                    v-if="
                      $v.familyEdit.givenName.$dirty &&
                      !$v.familyEdit.givenName.maxLength
                    "
                  >
                    100文字以上入力できません
                  </div>

                  <!-- <CInput
                label="名"
                class="required-mark"
                horizontal
                v-model="familyEdit.givenName" /> -->
                </CCol>

                <CCol lg="12">
                  <CInput
                    label="名（カナ）"
                    class="required-mark"
                    horizontal
                    v-model="familyEdit.lastName"
                  />
                  <div
                    class="text-danger input-info"
                    v-if="
                      $v.familyEdit.lastName.$dirty &&
                      !$v.familyEdit.lastName.required
                    "
                  >
                    名（カナ）の入力は必須です
                  </div>
                  <div
                    class="text-danger input-info"
                    v-if="
                      $v.familyEdit.lastName.$dirty &&
                      !$v.familyEdit.lastName.maxLength
                    "
                  >
                    100文字以上入力できません
                  </div>
                  <div
                    class="text-danger input-info"
                    v-if="
                      $v.familyEdit.lastName.$dirty &&
                      !$v.familyEdit.lastName.isKana
                    "
                  >
                    名（カナ）はカタカナを入力してください
                  </div>
                </CCol>

                <CCol lg="12">
                  <CSelect
                    label="関係"
                    horizontal
                    required
                    :options="options.relationOptions"
                    :value.sync="familyEdit.relation"
                  />
                </CCol>

                <CCol lg="12">
                  <CSelect
                    label="性別"
                    horizontal
                    required
                    :options="options.genderOptions"
                    :value.sync="familyEdit.gender"
                  />
                </CCol>
                <CCol lg="12">
                  <CInput
                    label="生年月日"
                    type="date"
                    min="1900-01-01"
                    max="2100-12-31"
                    horizontal
                    v-model="familyEdit.birth"
                  />
                </CCol>
              </CRow>
            </div>
            <template #footer>
              <CButton
                @click="editFamilyModal = false"
                color="secondary"
                class="float-left"
              >
                <i class="icon cil-x"></i> キャンセル
              </CButton>
              <CButton
                @click="
                  $v.familyEdit.$invalid
                    ? $v.familyEdit.$touch()
                    : onFamilySaveRunClick()
                "
                v-bind:class="$v.familyEdit.$invalid ? 'inactive' : 'active'"
                color="success"
              >
                <i class="icon cil-save"></i> 保存
              </CButton>
              <CButton @click="onFamilyDeleteClick()" color="danger">
                <i class="icon cil-trash"></i> 削除
              </CButton>
            </template>
          </CModal>
        </CRow>
      </CCol>
    </CRow>

    <CModal
      color="warning"
      :closeOnBackdrop="false"
      :centered="true"
      :show.sync="deleteConfirmModal"
    >
      削除してよろしいですか？
      <template #header> 削除確認</template>
      <template #footer>
        <CButton
          @click="deleteConfirmModal = false"
          color="secondary"
          class="float-left"
        >
          <i class="icon cil-x"></i> キャンセル
        </CButton>
        <CButton @click="onFamilyDeleteRunClick()" color="danger">
          <i class="icon cil-trash"></i> 実行
        </CButton>
      </template>
    </CModal>

    <CModal
      color="success"
      :closeOnBackdrop="false"
      :centered="true"
      :show.sync="deleteCompleteModal"
    >
      削除が完了しました。
      <template #header> 削除完了 </template>
      <template #footer>
        <CButton @click="deleteCompleteModal = false" color="success"
          ><i class="icon cil-x"></i> 閉じる</CButton
        >
      </template>
    </CModal>

    <CModal
      color="danger"
      :closeOnBackdrop="false"
      :centered="true"
      :show.sync="errorModal"
    >
      <p>会員情報の保存に失敗しました。</p>
      <p>登録済みのメールアドレスが入力された可能性があります。</p>
      <template #header> 会員情報保存エラー </template>
      <template #footer>
        <CButton @click="errorModal = false" color="danger"
          ><i class="icon cil-x"></i> 閉じる</CButton
        >
      </template>
    </CModal>

    <CButton
      color="success"
      class="my-5 btn px-5"
      @click="
        $v.cardUserData.$invalid || $v.query.$invalid
          ? $v.cardUserData.$touch()
          : saveProfile()
      "
      v-bind:class="
        $v.cardUserData.$invalid || $v.query.$invalid ? 'inactive' : 'active'
      "
      ><i class="icon cil-save"></i> 保存
    </CButton>

    <!-- 家族登録完了モーダル -->
    <CModal
      color="success"
      :closeOnBackdrop="false"
      :centered="true"
      :show.sync="completedModalFamily"
    >
      <template #header>
        <h4>更新完了</h4>
      </template>
      更新が完了しました。
      <template #footer>
        <CButton
          id="completedModalFamilyClose"
          @click="closeCompleteModalFamily"
          color="success"
          ><i class="icon cil-x"></i> 閉じる</CButton
        >
      </template>
    </CModal>

    <!-- 会員情報保存完了モーダル -->
    <CModal
      color="success"
      :closeOnBackdrop="false"
      :centered="true"
      :show.sync="completedModal"
    >
      <template #header>
        <h4>更新完了</h4>
      </template>
      更新が完了しました。
      <template #footer>
        <CButton @click="closeCompleteModal()" color="success"
          ><i class="icon cil-x"></i> 閉じる</CButton
        >
      </template>
    </CModal>
     
  </div>
</template>

<script>
// import Vue from 'vue'
import axios from "axios";
import {
  required,
  numeric,
  minLength,
  maxLength,
  email,
  helpers,
} from "vuelidate/lib/validators";
// import FamilyMember from "../components/FamilyMember";
import Options from "../components/Options";
import historykana from "historykana";
import * as wanakana from "wanakana";
const CARD_ID = { LENGTH: 16 };
const ZIPCODE_URL =
  "https://jxamy7mdqg.execute-api.ap-northeast-1.amazonaws.com/api/";

export default {
  components: {
    //FamilyMember
  },
  name: "MembersCardAdd",
  data() {
    return {
       
      notFound: false,
      updateUserComplete: false,
      errorModal: false,
      confirmModal: false,
      addFamilyModal: false,
      editFamilyModal: false,
      deleteConfirmModal: false,
      deleteCompleteModal: false,
      completedModal: false,
      completedModalFamily: false,
      cardIdEditModal: false,
      newMember: false,
      engFirstName: true,
      engLastName: true,
      engAddFamiFirstName: true,
      engAddFamiLastName: true,
      engEditFamiFirstName: true,
      engEditFamiLastName: true,
      gUserName: "",
      history: [],
      allGroups: [],
      UserGroups: [],
      userGroupName: "",
      UserGroup: "",
      admin: false,

      tableItems: [],
      copyItems: [],
      families: [],
      familyAdd: {
        firstName: "",
        lastName: "",
        familyName: "",
        givenName: "",
        birth: "",
      },
      familyEdit: {
        firstName: "",
        lastName: "",
        familyName: "",
        givenName: "",
        birth: "",
      },
      relationId: "",

      codeOptions: [],
      countryOptions: [],
      userGroupsOptions: [
        { value: "", label: "" },
        { value: "", label: "" },
        { value: "", label: "" },
      ],
      options: Options.data(),
      currentItems: {},

      // serchUserData:{},
      cardUserData: {
        firstName: "",
        lastName: "",
        familyName: "",
        givenName: "",
        gender: "",
        birth: "",
        userName: "",
        countryCode: "",
        email: "",
        mobile: "",
        address: {
          state: "",
          city: "",
          address1: "",
          address2: "",
          zipCode: "",
          country: {
            id: "",
            name: "",
            fullName: "",
            alpha2: "",
            alpha3: "",
            dial: "",
            flagData: "",
          },
        },
      },
      userGroupEdit: {
        userGroupSelected: "",
      },
      newCardId: "",
      query: {
        cardId: "",
      },
      valid: {
        cardId: { length: CARD_ID.LENGTH },
      },
    };
  },

  created() {
    this.cardUserData.name = this.$route.params.userId;
    if (this.$route.params.success) {
      this.newMember = true;
      setTimeout(() => (this.newMember = false), 2000);
    }
  },
  validations() {
    const isKana = helpers.regex("isKana", /^([ァ-ヴ][ァ-ヴー・]*)$/);

    return {
      query: {
        cardId: {
          required,
          minLength: minLength(16),
          maxLength: maxLength(16),
        },
      },
      cardUserData: {
        cardId: { required },
        familyName: { required, maxLength: maxLength(100) },
        firstName: {
          required,
          maxLength: maxLength(100),
          isKana: this.engFirstName ? false : isKana,
        },
        givenName: { required, maxLength: maxLength(100) },
        lastName: {
          required,
          maxLength: maxLength(100),
          isKana: this.engLastName ? false : isKana,
        },
        mobile: {
          required,
          maxLength: maxLength(15),
          numeric,
        },
        email: {
          // required,
          email,
        },
        // birth: {
        //   numeric,
        //   maxLength: maxLength(8),
        // },
        address: {
          zipCode: {
            maxLength: maxLength(20),
          },
          state: {
            maxLength: maxLength(50),
          },
          city: {
            maxLength: maxLength(50),
          },
          address1: {
            maxLength: maxLength(50),
          },
          address2: {
            maxLength: maxLength(50),
          },
        },
      },
      familyEdit: {
        familyName: { required, maxLength: maxLength(100) },
        firstName: {
          required,
          maxLength: maxLength(100),
          isKana: this.engEditFamiFirstName ? false : isKana,
        },
        givenName: { required, maxLength: maxLength(100) },
        lastName: {
          required,
          maxLength: maxLength(100),
          isKana: this.engEditFamiLastName ? false : isKana,
        },
        // birth: {
        //   numeric,
        //   maxLength: maxLength(8),
        // },
      },
      familyAdd: {
        familyName: { required, maxLength: maxLength(100) },
        firstName: {
          required,
          maxLength: maxLength(100),
          isKana: this.engAddFamiFirstName ? false : isKana,
        },
        givenName: { required, maxLength: maxLength(100) },
        lastName: {
          required,
          maxLength: maxLength(100),
          isKana: this.engAddFamiLastName ? false : isKana,
        },
        // birth: {
        //   numeric,
        //   maxLength: maxLength(8),
        // },
      },
      newCardId: {
        required,
        numeric,
        minLength: minLength(CARD_ID.LENGTH),
        maxLength: maxLength(CARD_ID.LENGTH),
      },
    };
  },

  filters: {
    genderString: function (value) {
      if (!value) return "公開しない";
      var retString;
      switch (value) {
        case "UNKONWN":
          retString = "公開しない";
          break;
        case "MALE":
          retString = "男性";
          break;
        case "FEMALE":
          retString = "女性";
          break;
        default:
          retString = "未知";
          break;
      }
      return retString;
    },
  },

  methods: {
    onSearchQuery: function (event, value) {
      // 日本語入力中のEnterキー操作は無効
      if (event.keyCode !== 13) return;
      switch (value) {
        case "cardId":
          if (!this.query.cardId) return;
          break;

        default:
          return;
      }
      this.updateUserComplete = false;
      this.getSearchQuery(value);
    },

    getSearchQuery: function (value) {
      var urlRequest;
      switch (value) {
        case "cardId":
          urlRequest = "/rest/users?card=" + this.query.cardId;
          break;
        default:
          urlRequest = "error";
      }

      this.loading = true;

      axios
        .get(urlRequest, {
          headers: { Authorization: `Bearer ${this.$keycloak.token}` },
        })
        .then((resp) => {
          console.log(resp.data);

          // this.serchUserData = resp.data
          this.cardUserData = resp.data[0];
          console.log(this.cardUserData.name);
          console.log(this.cardUserData);
          //検索時に家族情報取得
          this.getFamilies();
        })
        .catch((err) => {
           
          console.log(err);
          this.notFound = true;
        });
    },

    // put profiel update
    saveProfile: function () {
      console.log(this.cardUserData.birth);

      var urlRequest;
      urlRequest = "/rest/users/" + this.cardUserData.name;
      console.log(this.cardUserData.name);
      axios
        .put(urlRequest, this.cardUserData, {
          headers: { Authorization: `Bearer ${this.$keycloak.token}` },
        })
        .then((resp) => {
          console.log("User profile updated:" + resp.data);
          //this.getUserInformation();
          this.completedModal = true;
          this.memberFormReset();
          this.scrollTop();
        })
        .catch((err) => {
           
          // this.completedModal = true;
          // this.memberFormReset();
          // this.scrollTop();
          console.log("Updating profile error: " + err);
          this.errors = err;
          this.errorModal = true;
        });
    },

    /**
     * 会員登録完了モーダル閉じる
     */
    closeCompleteModal: function () {
      this.completedModal = false;
      document.getElementById("cardIDForm").focus();
    },

    /**
     * フォーム内リセット
     *
     */
    memberFormReset: function () {
      this.query.cardId = "";
      this.cardUserData.cardId = "";
      this.cardUserData.familyName = "";
      this.cardUserData.givenName = "";
      this.cardUserData.firstName = "";
      this.cardUserData.lastName = "";
      this.cardUserData.mobile = "";
      this.cardUserData.email = "";
      this.cardUserData.gender = "";
      this.cardUserData.birth = "";
      this.cardUserData.address.zipCode = "";
      this.cardUserData.address.state = "";
      this.cardUserData.address.city = "";
      this.cardUserData.address.address1 = "";
      this.cardUserData.address.address2 = "";
      this.cardUserData.address.address1 = "";
      this.cardUserData.name = "";

      this.families = [];

      console.log(this.families);
    },

    scrollTop: function () {
      window.scrollTo({
        top: 0,
        behavior: "instant",
      });
    },

    /**
     * 住所自動入力ボタンクリック
     */
    onInputAddressClick() {
      this.getAddress();
    },

    /**
     * 住所取得
     */
    getAddress: function () {
      // Get address by zipcode
      const urlRequest =
        ZIPCODE_URL + "?postcode=" + this.cardUserData.address.zipCode;

      axios
        .get(urlRequest)
        .then((resp) => {
          console.log("resp.data: ", resp.data);
          this.cardUserData.address.state = resp.data.PrefecturesName;
          this.cardUserData.address.city =
            resp.data.CityName + resp.data.TownName;
        })
        .catch((err) => {
           
          console.log(err);
        });
    },

    /**
     * Eメールアドレス承認状態
     */
    emailVerifiedString: function (value) {
      if (!value) return "不明";
      switch (value) {
        case true:
          return "承認済み";
        case false:
          return "未承認";
        default:
          return "不明";
      }
    },

    //#endregion ===== event =====

    //#region FamilyMember !!HACK!!

    /**
     * 家族会員登録の実装
     */
    addFamily() {
      var urlRequest = "/rest/users/" + this.cardUserData.name + "/relative";

      console.log(this.familyAdd);
      axios
        .post(urlRequest, this.familyAdd, {
          headers: { Authorization: `Bearer ${this.$keycloak.token}` },
        })
        .then((resp) => {
          console.log("Family added:" + JSON.stringify(resp.data));
          this.getFamilies();
        })
        .catch((err) => {
           
          console.log("Family added error: " + err);
          this.errors = err;
        });
    },

    /**
     * 全家族会員の取得
     */
    getFamilies() {
      var urlRequest = "/rest/users/" + this.cardUserData.name + "/relative";

      axios
        .get(urlRequest, {
          headers: { Authorization: `Bearer ${this.$keycloak.token}` },
        })
        .then((resp) => {
          console.log("Families get: ");
          console.log(resp.data);
          this.families = [];
          this.families = resp.data;
          // this.familyNotFound=false;
        })
        .catch((err) => {
           
          console.log("Families get error: " + err);
          this.errors = err;
          // this.familyNotFound=true;
        });
    },

    /**
     * 家族1人更新リクエスト
     */
    putFamily() {
      // NOTE: 会員更新同様の処理を行う
      var urlRequest = "/rest/users/" + this.familyEdit.userName;

      console.log(this.familyEdit);
      axios
        .put(urlRequest, this.familyEdit, {
          headers: { Authorization: `Bearer ${this.$keycloak.token}` },
        })
        .then((resp) => {
          console.log("Family put:" + JSON.stringify(resp.data));
          // NOTE: 会員更新は関係がないため、別途関係更新リクエストが必要
          this.putRelation();
          this.getFamilies();
        })
        .catch((err) => {
           
          console.log("Family put error: " + err);
          this.errors = err;
        });
    },

    /**
     * 関係更新リクエスト
     */
    putRelation() {
      // NOTE: 会員と家族の関係更新のみの処理を行う
      var urlRequest =
        "/rest/users/" +
        this.cardUserData.name +
        "/relative/" +
        this.relationId;

      const body = {
        name: this.familyEdit.relation,
        description: this.familyEdit.relation,
      };

      console.log(body);
      axios
        .put(urlRequest, body, {
          // .put(urlRequest, this.familyEdit, {
          headers: { Authorization: `Bearer ${this.$keycloak.token}` },
        })
        .then((resp) => {
          console.log("Relation put:" + JSON.stringify(resp.data));
          this.getFamilies();
        })
        .catch((err) => {
           
          console.log("Family put error: " + err);
          this.errors = err;
        });
    },

    /**
     * 家族1人削除リクエスト
     */
    deleteFamily() {
      var urlRequest =
        "/rest/users/" +
        this.cardUserData.name +
        "/relative/" +
        this.relationId;

      axios
        .delete(urlRequest, {
          headers: { Authorization: `Bearer ${this.$keycloak.token}` },
        })
        .then((resp) => {
          console.log("Family deleted:" + JSON.stringify(resp.data));
          this.getFamilies();
        })
        .catch((err) => {
           
          console.log("Family delete error: " + err);
          this.errors = err;
        });
    },

    /**
     * 家族登録モーダル表示ボタンクリック
     */
    onFamilyAddClick() {
      // 家族登録ダイアログのデータを初期化
      {
        this.familyAdd.givenName = "";
        this.familyAdd.familyName = this.cardUserData.familyName;
        // NOTE: 家族の氏名(カナ)は逆転しているのでこれで正しく動く
        this.familyAdd.lastName = "";
        this.familyAdd.firstName = this.cardUserData.firstName;
        this.familyAdd.gender = "UNKNOWN";
        this.familyAdd.birth = "";
        // note: passwordはパラメータ必須。値は空でよい。
        this.familyAdd.password = "";
        this.familyAdd.relation = "OTHER";
      }

      this.addFamilyModal = true;
    },

    /**
     * 家族登録ボタンクリック
     */
    onFamilyAddRunClick() {
      this.addFamily();
      this.addFamilyModal = false;
      this.completedModalFamily = true;
      // document.activeElement.blur();
      // document.getElementById("completedModalFamilyClose").focus();
    },

    /**
     * 家族登録完了モーダル閉じる
     */
    closeCompleteModalFamily: function () {
      this.completedModalFamily = false;
      document.getElementById("completeFamilyModal").focus();
    },

    /**
     * 家族編集ボタンクリック
     */
    onFamilyEditClick(id) {
      this.relationId = id;
      const editData = this.families.filter((a) => a.id == id)[0];

      // 家族編集ダイアログのデータを初期化
      {
        this.familyEdit.givenName = editData.relative.givenName || "";
        this.familyEdit.familyName = editData.relative.familyName || "";
        this.familyEdit.lastName = editData.relative.lastName || "";
        this.familyEdit.firstName = editData.relative.firstName || "";
        this.familyEdit.gender = editData.relative.gender || "UNKNOWN";
        this.familyEdit.birth = editData.relative.birth || "";
        // note: passwordはパラメータ必須。値は空でよい。
        this.familyEdit.password = "";
        this.familyEdit.relation = editData.description || "OTHER";
        // this.familyEdit.relationName = editData.name || "OTHER";
        this.familyEdit.userName = editData.relative.name || "";
        this.familyEdit.cardId = editData.relative.cardId || "";
        this.familyEdit.id = editData.relative.id || "";
        this.familyEdit.name = editData.relative.name || "";
        this.familyEdit.status = editData.relative.status || "";
      }

      this.editFamilyModal = true;
    },

    /**
     * 家族保存ボタンクリック
     */
    onFamilySaveRunClick() {
      this.putFamily();
      this.editFamilyModal = false;
      this.completedModalFamily = true;
    },

    /**
     * 家族削除ボタンクリック
     */
    onFamilyDeleteClick() {
      this.deleteConfirmModal = true;
    },

    /**
     * 家族削除実行ボタンクリック
     */
    onFamilyDeleteRunClick() {
      this.deleteFamily();
      this.editFamilyModal = false;
      this.deleteConfirmModal = false;
      this.deleteCompleteModal = true;
    },

    //#eneregion FamilyMember
    // TODO:firstName,lastNameは現在逆に使われている、全画面で修正が必要
    familyName_furigana(input) {
      if (wanakana.isRomaji(input.target.value)) {
        this.cardUserData.firstName = input.target.value;
        this.engFirstName = true;
      } else {
        this.engFirstName = false;
        this.history.push(input.target.value);
        this.cardUserData.firstName = wanakana.toKatakana(
          historykana(this.history)
        );
      }
    },
    givenName_furigana(input) {
      if (wanakana.isRomaji(input.target.value)) {
        this.cardUserData.lastName = input.target.value;
        this.engLastName = true;
      } else {
        this.engLastName = false;
        this.history.push(input.target.value);
        this.cardUserData.lastName = wanakana.toKatakana(
          historykana(this.history)
        );
      }
    },
    familySave_familyName_furigana(input) {
      if (wanakana.isRomaji(input.target.value)) {
        this.familyAdd.firstName = input.target.value;
        this.engAddFamiFirstName = true;
      } else {
        this.engAddFamiFirstName = false;
        this.history.push(input.target.value);

        this.familyAdd.firstName = wanakana.toKatakana(
          historykana(this.history)
        );
      }
    },
    familySave_givenName_furigana(input) {
      if (wanakana.isRomaji(input.target.value)) {
        this.familyAdd.lastName = input.target.value;
        this.engAddFamiLastName = true;
      } else {
        this.engAddFamiLastName = false;
        this.history.push(input.target.value);

        this.familyAdd.lastName = wanakana.toKatakana(
          historykana(this.history)
        );
      }
    },
    familyEdit_familyName_furigana(input) {
      if (wanakana.isRomaji(input.target.value)) {
        this.familyEdit.firstName = input.target.value;
        this.engEditFamiFirstName = true;
      } else {
        this.engEditFamiFirstName = false;
        this.history.push(input.target.value);

        this.familyEdit.firstName = wanakana.toKatakana(
          historykana(this.history)
        );
      }
    },
    familyEdit_givenName_furigana(input) {
      if (wanakana.isRomaji(input.target.value)) {
        this.familyEdit.lastName = input.target.value;
        this.engEditFamiLastName = true;
      } else {
        this.engEditFamiLastName = false;
        this.history.push(input.target.value);

        this.familyEdit.lastName = wanakana.toKatakana(
          historykana(this.history)
        );
      }
    },
  },
  beforeMount() {
    // this.getAllGroup();
    // this.getUserGroup();
    // this.getFamilies();
  },
  computed: {
    ConvertId: {
      get() {
        return this.query.cardId;
      },
      set(value) {
        var conv = value.replace(/[\uff01-\uff5e]/g, function (ch) {
          return String.fromCharCode(ch.charCodeAt(0) - 0xfee0);
        });
        this.query.cardId = conv;
      },
    },
  },
};
</script>
<style>
.expand-transition {
  transition: all 2s ease;
  height: 30px;
  padding: 10px;
}

.expand-enter,
.expand-leave {
  height: 0;
  padding: 0 10px;
  opacity: 0;
}

input[type="number"]::-webkit-outer-spin-button,
input[type="number"]::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

input[type="number"] {
  -moz-appearance: textfield;
}
</style>
